import React, { useState } from 'react';
import QuestionContent1 from './questioncontent1'; // Import reportcontent1
import QuestionContent2 from './questioncontent2'; // Import reportcontent2
import QuestionContent3 from './questioncontent3'; // Add more content components as needed
import QuestionContent4 from './questioncontent4'; // Add more content components as needed
import ReportSubmited from '../reportsubmited'; // Import the ReportSubmited component
import axios from 'axios';
import { api_url } from '../../constants/data';
import ReactLoading from "react-loading";
import { useNavigate } from 'react-router-dom';


function QuestionMain() {
  const [content, setContent] = useState(1); // State to track which content to display, starting from 1 (for content1)
  const [showStepCount, setShowStepCount] = useState(true); // State to toggle the step counter visibility
  const [form, setForm] = useState(true); 
  const [loader, setLoader] = useState(false); 
  const [emailPassword, setEmailPassword] = useState(null); 
  const token = localStorage.getItem('auth_token')
  const navigate = useNavigate()

  const _OnNext = ({ data }) => {
    const fm = {...form}
    Object.keys(data).map(x => {
      fm[x] = data[x]
    })

    setForm({...fm})
    if (content === contentArray.length - 1) {
      const fd = new FormData()
      setLoader(true)
      fd.append('file', fm.selectedFiles[0])
      fd.append('internal', fm.internal)
      fd.append('surname', fm.surname)
      fd.append('email', fm.email)
      fd.append('phone', fm.phone)
      fd.append('relationship', fm.relationship)
      fd.append('share_personal_info', fm.selectAnoymouslyradio == 'Yes')
      fd.append('question', fm.question)
      fd.append('user_email', fm.email)

      const header = !token ? {} : {
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }

      axios.post(`${api_url}/question/store`, fd, header).then(res => {
        setEmailPassword({
          email: res.data.email,
          password: res.data.password,
        })
        
        if(token){
          navigate('/')
        }

        setShowStepCount(false)

      }).catch(err => {
        console.error(err)
      }).finally(() => {
        setLoader(false)
      })
    }

    setContent((prevContent) => {
      const nextContent = prevContent + 1;
      if (nextContent === contentArray.length - 1) {
        // setShowStepCount(false); // Hide step count when navigating to ReportSubmited


      }
      return Math.min(nextContent, contentArray.length); // Ensure we don't exceed the number of steps
    });
  };

  const handleStepClick = (step) => {
    setContent(step); 
    if (step === contentArray.length - 1) {
      setShowStepCount(false); 

    } else {
      setShowStepCount(true); 
    }
  };
  const _OnBack = () => {
    setContent((prevContent) => {
      const prevContentIndex = prevContent - 1;
      if (prevContentIndex < 0) {
        return 0; 
      }
      return prevContentIndex; 
    });
  };
  const contentArray = [
    <QuestionContent1 onNext={_OnNext} onBack={_OnBack} />,
    <QuestionContent2 onNext={_OnNext} onBack={_OnBack}/>,
    <QuestionContent3 onNext={_OnNext} onBack={_OnBack}/>,
    <QuestionContent4 onNext={_OnNext} onBack={_OnBack}/>,
    <ReportSubmited  email={emailPassword?.email} password={emailPassword?.password} />,
  ];

  return (
    <div className="report-content">
      {/* Conditional rendering of the header */}
      {showStepCount && (
        <div className="report-header">
          <div className="title-stepcount">
            <h1>Question Form</h1>
            <p>
              Step <span>{content}</span> of {contentArray.length - 1}
            </p>
          </div>
          <div className="stepindicator">
           
            {contentArray.slice(0, contentArray.length - 1).map((_, index) => (
              <button
                key={index}
                className={content >= index + 1 ? 'active' : ''}
                onClick={() => handleStepClick(index + 1)}
              ></button>
            ))}
          </div>
        </div>
      )}

      {!loader && (
        <div className="report-body">
          {contentArray[content - 1]} 
        </div>
      )}

      { loader && (
        <div className="report-body" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '300px' }}>
          <ReactLoading type={'spin'} color="#007dfc" />
        </div>
      ) }
    </div>
  );
}

export default QuestionMain;
